import type {CompanyContact} from 'types/entities/CompanyContact'

export const filterActiveCompanyContacts = (contacts: CompanyContact[]): CompanyContact[] =>
    contacts.filter((contact) => !contact.deleted_at)
